import React, { useState } from 'react';
import {
    TableCell,
    Typography,
    Tooltip,
    IconButton,
} from '@mui/material';
import { Grey2 } from '../../../../color_utils';
import { trakrefFontFamily } from '../../../../utils';
import CreateIcon from '@mui/icons-material/Create';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import StyledTableRow from './StyledTableRow'
import useEmailAlert from '../context/useEmailAlert';

const RowTable = ({ rowData }) => {

    const { onDeleteEmailAlert, onGetByEmailAddress  } = useEmailAlert();

    const [openArrow, setOpenArrow] = useState(false);

    const cellActionItemsStyle = {
        textAlign: "right",
        border: 'none'
    }

    const cellRowTextStyle = {
        "&.MuiTypography-root": {
            color: Grey2,
            fontFamily: trakrefFontFamily,
            fontSize: "13px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
            letterSpacing: "0.089px",
        },
    }

    const cellRowTextStyle2 = {
        "&.MuiTypography-root": {
            color: Grey2,
            fontFamily: trakrefFontFamily,
            fontSize: "13px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
            letterSpacing: "0.089px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            wordWrap: "break-word",
        },
    }

    const hasMultipleRegion = rowData.regions.length > 1;
    const regionsEmailAlerts = hasMultipleRegion
        ? rowData.regions.map(x => x.emailAlerts.map(o => o.emailAlertName)).flat().join('; ')
        : rowData.regions[0].emailAlerts.map(x => x.emailAlertName).join('; ');
    const regionTitle = hasMultipleRegion ? "Multiple Regions" : (rowData.regions[0].instanceAssociationName);

    return (
        <>
            <StyledTableRow>
                <TableCell style={{ maxWidth: "40px", border: 'none' }}>
                    <Typography sx={cellRowTextStyle}>
                        {rowData.emailAddress}
                    </Typography>
                </TableCell>
                <TableCell style={{ maxWidth: "400px", border: 'none' }}>
                    <div style={{
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "10px"
                    }}>
                        <Typography sx={cellRowTextStyle2}>
                            <span style={{ fontWeight: 600 }}> {regionTitle ? `${regionTitle}: ` : `Without Assigned Region: `}</span> {regionsEmailAlerts}
                        </Typography>
                        {
                            !openArrow
                                ? <KeyboardArrowDownIcon
                                    onClick={() => setOpenArrow(x => !x)}
                                    sx={{ "&.MuiSvgIcon-root": { fontSize: "12px", color: "#000000" } }}
                                />
                                : <KeyboardArrowUpIcon
                                    onClick={() => setOpenArrow(x => !x)}
                                    sx={{ "&.MuiSvgIcon-root": { fontSize: "12px", color: "#000000" } }}
                                />
                        }
                    </div>
                </TableCell>
                <TableCell style={cellActionItemsStyle}>
                    <Tooltip title={"Edit Alert"}>
                        <IconButton onClick={async () => await onGetByEmailAddress(rowData.emailAddress, "edit")}>
                            <CreateIcon sx={{ color: Grey2 }} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Duplicate Alert"}>
                        <IconButton onClick={async () => await onGetByEmailAddress(rowData.emailAddress, "duplicate")}>
                            <ContentCopyRoundedIcon sx={{ color: Grey2 }} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Delete Alert"}>
                        <IconButton onClick={async () => await onDeleteEmailAlert(rowData.emailAddress)}>
                            <DeleteIcon sx={{ color: Grey2 }} />
                        </IconButton>
                    </Tooltip>
                </TableCell>
            </StyledTableRow>
            {
                openArrow && rowData.regions.map(x => {
                    const alerts = x.emailAlerts.map(x => x.emailAlertName).join('; ');
                    return (
                        <StyledTableRow sx={{ ...(!openArrow && { display: 'none' }) }}>
                            <TableCell style={{ maxWidth: "40px", border: 'none' }}>
                            </TableCell>
                            <TableCell style={{ maxWidth: "200px", border: 'none' }}>
                                <div style={{
                                    display: "flex",
                                    alignContent: "center",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "10px",
                                    padding: "10px 10px 10px 20px"
                                }}>
                                    <Tooltip title={alerts}>
                                        <Typography sx={cellRowTextStyle2}>
                                            {
                                                x.instanceAssociationName && <span style={{ fontWeight: 600 }}> {x.instanceAssociationName}: </span>
                                            }
                                            {alerts}
                                        </Typography>
                                    </Tooltip>
                                </div>
                            </TableCell>
                            <TableCell style={cellActionItemsStyle}>
                            </TableCell>
                        </StyledTableRow>
                    )
                })
            }
        </>
    )
}

export default RowTable;